export default __webpack_public_path__ + "static/media/section3-icon2.a6cca124.png";